import React from 'react'
import { useTemplate } from './TemplateProvider'
import { availableFontNames } from './index'
import SliderControl from './SliderControl'
import SelectControl from './SelectControl'
import ColorPickerControl from './ColorPickerControl'
import { useTranslation } from '~/hooks/useTranslation'

const formatDecimal = (value) => {
  if (value >= 1.0) {
    return value.toFixed(2)
  } else {
    return value.toFixed(2).slice(1)
  }
}

const formatInches = (value) => {
  return `${formatDecimal(value)} in`
}

const formatPixels = (value) => {
  return `${value} px`
}

const formatPercent = (value) => {
  return `${Math.round(value * 100)}%`
}

const StyleEditor = () => {
  const { t } = useTranslation('StyleEditor')
  const { templateSettings, devMode } = useTemplate()

  return (
    <>
      <div className="mb-6 text-lg font-medium text-primary">
        {t('styling')}
      </div>
      <SelectControl title={t('primary_font')} settingName="primaryFontFamily">
        {availableFontNames.map((font) => (
          <option key={font} value={font}>
            {font}
          </option>
        ))}
      </SelectControl>
      <SelectControl title={t('accent_font')} settingName="secondaryFontFamily">
        {availableFontNames.map((font) => (
          <option key={font} value={font}>
            {font}
          </option>
        ))}
      </SelectControl>
      <SliderControl
        title={t('heading_font_size')}
        min={16}
        max={48}
        step={1}
        settingName="headingFontSize"
        formattingFunction={formatPixels}
      />
      <SliderControl
        title={t('body_font_size')}
        min={8}
        max={24}
        step={1}
        settingName="bodyFontSize"
        formattingFunction={formatPixels}
      />
      <ColorPickerControl settingName="accentColor" title={t('accent_color')} />
      <SliderControl
        title={t('line_height')}
        min={0.5}
        max={1.5}
        step={0.01}
        settingName="lineHeightMultiplier"
        formattingFunction={formatPercent}
      />
      <SliderControl
        title={t('list_line_height')}
        min={0.5}
        max={1.5}
        step={0.01}
        settingName="listLineHeightMultiplier"
        formattingFunction={formatPercent}
      />

      <div className="mb-6 text-lg font-medium text-primary">
        {t('page_setup')}
      </div>
      <SelectControl title={t('paper_size')} settingName="size">
        <option value="Letter">{t('letter_size')}</option>
        <option value="A4">{t('a4_size')}</option>
      </SelectControl>
      <SliderControl
        title={t('top_and_bottom_margin')}
        min={0.4}
        max={1.5}
        step={0.01}
        settingName="yMargin"
        formattingFunction={formatInches}
      />
      <SliderControl
        title={t('left_and_right_margin')}
        min={0.4}
        max={1.5}
        step={0.01}
        settingName="xMargin"
        formattingFunction={formatInches}
      />
      {devMode && <pre>{JSON.stringify(templateSettings, null, 2)}</pre>}
    </>
  )
}

export default StyleEditor
